import { get } from "ol/proj";

export default {
  // 获取report 总数  新接口
  getAllReportList: "/report/jobRequest/maintenance/maintenanceReport",
  // non maintenance details 追加文件上传功能
  getNonMaintenanceAddFiles: "/maintenance/non/addFiles",
  // 获取Supervisor列表
  getSupervisorList: "/accountSupervisor/getSupervisorList",
  // 获取ready to pay maintace report  旧接口
  getReadyReportList: "/maintenance/getReadyReportList",
  // 获取ready to pay maintace report  新接口
  getReadyReportHistoryList:
    "/report/jobRequest/maintenance/maintenanceHistoryReport",
  // 获取jobRequest report 统计数据
  getMaintenanceVendorReport:
    "/report/jobRequest/maintenance/maintenanceVendorReport",
  // 获取所属范围内vendor对正在进行的工单打卡情况
  getMoWorkerInvoiceReport:
    "/report/jobRequest/maintenance/monWorkerRunningInvoiceReport",
  //获取vendor对完成工单打卡情况
  getMonWorkerCompletedInvoiceReport:
    "/report/jobRequest/maintenance/monWorkerCompletedInvoiceReport",
  // 获取vendor day  report
  getMaintenanceVendorDaysReport:
    "/report/jobRequest/maintenance/maintenanceVendorDaysReport",
  // vendor Name列表
  maintenanceVendorList: "/report/jobRequest/maintenance/vendor",
  // maintenanceVendorCostReport列表
  maintenanceVendorCostReport:
    "/report/jobRequest/maintenance/maintenanceVendorCostReport",
  // report点击查询maintenanceId跳转
  reportGetMaintenanceIds: "/report/jobRequest/maintenance/vendor/ids",
  // report模块Maintenance Vendor Cost Report  点击跳转ids
  maintenanceCountVendorCostIds:
    "/report/jobRequest/maintenanceCount/vendorCost/ids",
  //    report 模块获取generalLedger列表数据
  getGeneralLedgerShow: "/report/generalLedger/show",
  //    report 模块获取generalLedger 下载PDF
  getGeneralLedgerToPdf: "/report/generalLedger/export/pdf",
  //    report 模块获取generalLedger 下载CSV
  getGeneralLedgerToCsv: "/report/generalLedger/export/csv",
  //   checkNo 详情
  getCheckNoDetail:"/report/generalLedger/showCheckNoDetail",
  // One Line Cash Flow report preview and direct in-memory downloads.
  getOneLineCashFlowShow: "/report/oneLineCashFlow/show",
  getOneLineCashFlowToPdf: "/report/oneLineCashFlow/export/pdf",
  getOneLineCashFlowToCsv: "/report/oneLineCashFlow/export/csv",
  // Cash Position keeps total overview and the expandable detail as separate requests.
  getCashPositionOwners: "/report/cashPosition/options/owners",
  getCashPositionTrusts: "/report/cashPosition/options/trusts",
  getCashPositionBankNames: "/report/cashPosition/options/bankNames",
  getCashPositionOverview: "/report/cashPosition/overview",
  getCashPositionDetail: "/report/cashPosition/detail",
  getCashPositionToPdf: "/report/cashPosition/export/pdf",
  getCashPositionToExcel: "/report/cashPosition/export/excel",
  // Accounting Report 8825 preview and direct in-memory downloads.
  getAccounting8825Show: "/report/accounting8825/show",
  getAccounting8825ToPdf: "/report/accounting8825/export/pdf",
  getAccounting8825ToCsv: "/report/accounting8825/export/csv",
  getAccounting8825Rules: "/report/accounting8825/rules",
  saveAccounting8825Rule: "/report/accounting8825/rules/save",
  deleteAccounting8825Rule: "/report/accounting8825/rules/delete",
  // RES report preview and direct in-memory downloads.
  getResReportShow: "/report/res/show",
  getResReportToPdf: "/report/res/export/pdf",
  getResReportToCsv: "/report/res/export/csv",
  getResReportRules: "/report/res/rules",
  saveResReportRule: "/report/res/rules/save",
  deleteResReportRule: "/report/res/rules/delete",
  getReportConfigNames: "/report/config/names",
  // tenant Delinquency
  getDelinquencyShow:"/report/tenantDelinquency/tenantDelinquencyReport",
  // tenant Delinquency 通过Supervisor查询到相关prop详情
  getDelinquencyByProp:"/report/tenantDelinquency/showSupervisorDetail",
  // tenant Delinquency  查看prop 详情接口
  getDelinquencyByPropDetail:"/report/tenantDelinquency/showPropertyDetail",
  // 月度租金收取统计卡片
  getCollectionShowSummary:"/report/monthlyRentCollectionReport/showSummary",
  // 月度租金收取列表
  getCollectionShowList:"/report/monthlyRentCollectionReport/showDetails",
  // 获取近期2个月的时间
  getCollectionShowMonth:"/report/monthlyRentCollectionReport/showMonth",

};
